import { createActionName } from "../../../utility"

export const reducerName = "journeyEdit"

export const SCROLL_POSITION = createActionName(reducerName, "SCROLL_POSITION")
export const RULES_PANEL = createActionName(reducerName, "RULES_PANEL")
